module.exports = __webpack_public_path__ + "img/onlineApply.2d0fb760.png";